<script>
  let { animated = true, title = "Title", subtitle = "Subtitle" } = $props();

  function animate(element) {
    element.classList.remove("tw:opacity-0", "tw:blur-xl");
  }
</script>

<div
  class="tw:group tw:isolate tw:m-2 tw:flex tw:grow tw:flex-col tw:items-start"
>
  <h3
    class={[
      "tw:pb-0 tw:text-2xl tw:leading-7 tw:text-zinc-950 tw:capitalize",
      animated && "tw:opacity-0 tw:blur-xl tw:transition-all tw:duration-500",
    ]}
    {@attach animated && animate}
  >
    {title}
  </h3>
  <p
    class={[
      "tw:text-base tw:text-zinc-500",
      animated && "tw:opacity-0 tw:blur-xl tw:transition-all tw:duration-500",
    ]}
    {@attach animated && animate}
  >
    {@html subtitle}
  </p>
</div>
